import Clients from 'dash/js/services/Clients'

/**
 * @param {*} param0
 */
export const retrieveClients = async ({ commit }) => {
  await Clients.retrieve().then(response => commit('retrieveClients', response.data))
}

/**
 * @param {*} param
 * @param {*} clientSettingsData
 */
export const updateClientSettings = async ({ commit }, data) => {
  const { clientId, payload } = data

  await Clients.update(clientId, { settings: payload })
}
